import createSelector from "./createSelector";

const modelRenderer = (params = {}) => {
    const { animation = false, variant = false, wrapper } = params;
    if (!wrapper) {
        return;
    }

    //model viewer
    const modelViewer = wrapper.querySelector("model-viewer");
    if (!modelViewer) return false;

    if (modelViewer.src) {
        try {
            const source = new URL(modelViewer.src);
            if (source?.protocol !== window.location.protocol) {
                modelViewer.src = source.href.replace(source.protocol, window.location.protocol);
            }
        } catch (error) {
            console.warn(error.message, modelViewer.src);
        }
    }

    const selectedAnimation = modelViewer.dataset.animation;

    const select = wrapper.querySelector("#variant");
    const animations = wrapper.querySelector("#animations");
    const percentageWrapper = wrapper.querySelector(".percentageWrapper");
    const percentageElement = percentageWrapper?.querySelector(".percentage");

    if (percentageWrapper && (modelViewer.reveal === "interaction" || modelViewer.loaded)) {
        percentageWrapper.style.display = "none";
    }

    modelViewer.addEventListener("load", () => {
        createSelector(select, modelViewer.availableVariants, "", variant);
        createSelector(animations, modelViewer.availableAnimations, selectedAnimation, animation);
        modelViewer.animationName = selectedAnimation;

        setTimeout(() => {
            if (percentageWrapper) {
                percentageWrapper.style.display = "none";
            }
        }, 100);
    });

    // hide the percentage wrapper if by chance  it does not hide after loading the model
    const interval = setInterval(() => {
        if (modelViewer.loaded) {
            clearInterval(interval);
        }
        if (percentageWrapper) {
            percentageWrapper.style.display = "none";
        }
    }, 5000);

    //show percentage
    if (percentageElement) {
        modelViewer.addEventListener("progress", (event) => {
            percentageWrapper.style.display = "block";
            percentageElement.innerHTML = parseInt(event.detail.totalProgress * 100) + "%";
        });
    }

    select &&
        select.addEventListener("input", (event) => {
            modelViewer.variantName = event.target.value;
        });
    animations &&
        animations.addEventListener("input", (event) => {
            modelViewer.animationName = event.target.value;
        });

    // slides
    const slides = wrapper.querySelectorAll(".slide");
    for (const slide of slides) {
        slide.addEventListener("click", (e) => {
            e.preventDefault();
            modelViewer.src = slide?.dataset?.source;
            modelViewer.poster = slide?.dataset?.poster;
            slides.forEach((element) => {
                element.classList.remove("selected");
            });
            slide.classList.add("selected");
            if (select) select.innerHTML = "";
        });
    }

    document.querySelector(".slider")?.addEventListener("beforexrselect", (ev) => {
        ev.preventDefault();
    });
    // });
}
export default modelRenderer;